import { ChangeDetectionStrategy, Component, OnInit, effect, inject } from '@angular/core';
import { VentasCementoStore } from '../../../stores/ventas-cemento.store';
import { CementoVentaApiService } from '../../../services/cemento-venta-api.service';
import { VentasCementoUiEffectsService } from '../ui-effects/ventas-cemento-ui-effects.service';

@Component({
  selector: 'app-ventas-cemento-page',
  templateUrl: './ventas-cemento-page.component.html',
  styleUrls: ['./ventas-cemento-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    CementoVentaApiService,
    VentasCementoStore,
    VentasCementoUiEffectsService,
  ],
})
export class VentasCementoPageComponent implements OnInit {
  readonly store = inject(VentasCementoStore);
  private readonly uiEffects = inject(VentasCementoUiEffectsService);

  constructor() {
    effect(() => {
      this.uiEffects.syncLoading(this.store.loading());
    });
  }

  ngOnInit(): void {
    this.store.loadVentas().subscribe({
      error: () => {
        this.uiEffects.showLoadError();
      },
    });
  }
}
